
/**
 * @param {?} seconds
 * @return {?}
 */
export function convertSecToMin(seconds: number): string {
  let /** @type {?} */ min = Math.floor(seconds / 60).toString();
  let /** @type {?} */ sec = (seconds % 60).toString();

  min = `0${min}`.slice(-2);
  sec = `0${sec}`.slice(-2);

  return `${min} : ${sec}`;
}
